/* eslint-disable */
export default {
  noResultFoundFor: 'Keine Ergebnisse gefunden für',
  foundFromServerHint:
    'Geben Sie das Schlüsselwort ein und drücken Sie die Eingabetaste, um in {appName} zu suchen',
  notResultFoundFromServer: 'Keine Ergebnisse gefunden',
  loading: 'Laden...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
